import React from 'react'
import PlansAndBillingComponent from '../../components/PlansAndBilling/PlansAndBilling'

export default function PlanAndBillingsView() {
  return (
    <PlansAndBillingComponent />
  )
}
